module.exports = __webpack_public_path__ + "static/media/icon_10.c228b36b.svg";